export const ALLOWED_SECRET_SCOPES = [
    "byo-api-keys",
    "sentry-token",
    "huggingface-token",
    "auraone-cloud-token",
    "enterprise-mtls-identity",
    "updater-signing-key",
    "intake-install-signing-key",
];
export function isAllowedSecretScope(scope) {
    return ALLOWED_SECRET_SCOPES.includes(scope);
}
export function validateKeychainKey(key) {
    for (const [field, value] of Object.entries(key)) {
        if (!/^[a-z0-9][a-z0-9_.-]*$/i.test(value)) {
            throw new Error(`Invalid keychain ${field}: ${value}`);
        }
    }
    if (!isAllowedSecretScope(key.scope)) {
        throw new Error(`Keychain scope is not approved for secret storage: ${key.scope}`);
    }
}
export function createTauriKeychainApi(invoke) {
    return {
        async set(key, value) {
            validateKeychainKey(key);
            await invoke("platform_keychain_set", {
                key,
                value,
                secret: true,
            });
        },
        async get(key) {
            validateKeychainKey(key);
            return invoke("platform_keychain_get", {
                key,
                secret: true,
            });
        },
        async delete(key) {
            validateKeychainKey(key);
            await invoke("platform_keychain_delete", { key });
        },
        async list(service, scope) {
            validateKeychainKey({ service, scope, identifier: "list" });
            return invoke("platform_keychain_list", { service, scope });
        },
    };
}
export const INTAKE_INSTALL_KEYPAIR_SCOPE = "intake-install-signing-key";
export const INTAKE_INSTALL_KEYPAIR_IDENTIFIER = "ed25519-install-keypair-v1";
export function intakeInstallSigningKeypairKey(service) {
    return {
        service,
        scope: INTAKE_INSTALL_KEYPAIR_SCOPE,
        identifier: INTAKE_INSTALL_KEYPAIR_IDENTIFIER,
    };
}
export async function ensureIntakeInstallSigningKeypair(keychain, service, generateKeypair) {
    const key = intakeInstallSigningKeypairKey(service);
    const existing = await keychain.get(key);
    if (existing) {
        const parsed = JSON.parse(existing);
        validateIntakeInstallSigningKeypair(parsed);
        return parsed;
    }
    const generated = await generateKeypair();
    validateIntakeInstallSigningKeypair(generated);
    await keychain.set(key, JSON.stringify(generated));
    return generated;
}
export function validateIntakeInstallSigningKeypair(keypair) {
    if (keypair.algorithm !== "Ed25519") {
        throw new Error("Intake install signing keypair must use Ed25519.");
    }
    if (!keypair.public_key.trim()) {
        throw new Error("Intake install signing keypair must include a public key.");
    }
    if (!keypair.private_key.trim()) {
        throw new Error("Intake install signing keypair must include a private key.");
    }
    if (Number.isNaN(Date.parse(keypair.created_at))) {
        throw new Error("Intake install signing keypair must include an ISO created_at timestamp.");
    }
}
